import React from 'react';
import RowCard from "../RowCard";
import RenderCol from "../RenderCol";
import {Button} from "react-bootstrap";
import {UncontrolledTooltip} from "reactstrap";
import RenderBettingItem from "./RenderBettingItem";

const BettingMobile = (props) => {
    const {
        posts,
        handlePostCheckChange,
        getSelectedPost,
        postItemsTemp,
        handleBetTypeCheckChange,
        handleMultipleCheckChange,
        selectedMulti,
        tempItem,
        onClearAll,
        handleSubmitEnter,
        betTypes: {activeBetTypeId, betType},
        handleSubmitPost
    } = props;

    return (
        <div className="form-betting w-right bg-grey">
            <div>
                <RowCard bodyClass="card-body d-flex w-100">
                    {posts.map((p, i) => {
                        return <button key={i}
                                       onClick={() => handlePostCheckChange(p.id)}
                                       className={`post ${p.checked ? "post-active" : ""}`}>{p.id}</button>
                    })}
                    <button key="all"
                            onClick={() => handlePostCheckChange("all")}
                            className={`post ${getSelectedPost().length === 4 ? "post-active" : ""}`}>ALL
                    </button>
                </RowCard>
                {!postItemsTemp && <RowCard bodyClass="card-body d-flex w-100">
                    <div className="d-flex w-100">
                        {betType.map((p, i) => {
                            return <button
                                key={i}
                                onClick={() => handleBetTypeCheckChange(p.id)}
                                className={`post type ${activeBetTypeId === p.id ? "post-active" : ""} ${p.id === "SPECIAL_RANGE" ? "fs-sp" : ""}`}>{p.title}</button>
                        })}
                        <button
                            onClick={handleMultipleCheckChange}
                            className={`post type ${selectedMulti ? "post-active" : ""}`}>គុណ
                        </button>
                    </div>
                </RowCard>}
                {!postItemsTemp && <RenderCol {...props} activeBetTypeId={activeBetTypeId} isMobile/>}
                {tempItem && <RowCard>
                    <Button
                        id="delete"
                        onClick={onClearAll}
                        className="bg-secondary border-0">
                        Cancel
                    </Button>
                    <Button id="save" onClick={handleSubmitEnter}
                            className='m-1'>
                        Save
                    </Button>
                    <UncontrolledTooltip placement="bottom" target="save">
                        Enter
                    </UncontrolledTooltip>
                </RowCard>}
                {postItemsTemp && <RowCard>
                    <Button
                        id="delete"
                        onClick={onClearAll}
                        className="bg-secondary border-0">
                        Cancel
                    </Button>
                    <Button id="save" onClick={handleSubmitPost}
                            className='m-1'>
                        Save
                    </Button>
                    <UncontrolledTooltip placement="bottom" target="save">
                        Enter
                    </UncontrolledTooltip>
                </RowCard>}
                <RenderBettingItem {...props}/>
            </div>
        </div>
    );
};

export default BettingMobile;